/* preact/hooks/dist/hooks.module.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const preact_1 = require("6f11f2ef27") /* preact */;
    var t, u, r, o = 0, i = [], c = preact_1.options.__b, f = preact_1.options.__r, e = preact_1.options.diffed, a = preact_1.options.__c, v = preact_1.options.unmount;
    function m(t, r) { preact_1.options.__h && preact_1.options.__h(u, t, o || r), o = 0; var i = u.__H || (u.__H = { __: [], __h: [] }); return t >= i.__.length && i.__.push({}), i.__[t]; }
    function l(n) { return o = 1, p(w, n); }
    exports.useState = l;
    function p(n, r, o) { var i = m(t++, 2); return i.t = n, i.__c || (i.__ = [o ? o(r) : w(void 0, r), function (n) { var t = i.t(i.__[0], n); i.__[0] !== t && (i.__ = [t, i.__[1]], i.__c.setState({})); }], i.__c = u), i.__; }
    exports.useReducer = p;
    function y(r, o) { var i = m(t++, 3); !preact_1.options.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__H.__h.push(i)); }
    exports.useEffect = y;
    function h(r, o) { var i = m(t++, 4); !preact_1.options.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__h.push(i)); }
    exports.useLayoutEffect = h;
    function s(n) { return o = 5, d(function () { return { current: n }; }, []); }
    exports.useRef = s;
    function _(n, t, u) { o = 6, h(function () { "function" == typeof n ? n(t()) : n && (n.current = t()); }, null == u ? u : u.concat(n)); }
    exports.useImperativeHandle = _;
    function d(n, u) { var r = m(t++, 7); return k(r.__H, u) && (r.__ = n(), r.__H = u, r.__h = n), r.__; }
    exports.useMemo = d;
    function A(n, t) { return o = 8, d(function () { return n; }, t); }
    exports.useCallback = A;
    function F(n) { var r = u.context[n.__c], o = m(t++, 9); return o.__c = n, r ? (null == o.__ && (o.__ = !0, r.sub(u)), r.props.value) : n.__; }
    exports.useContext = F;
    function T(t, u) { preact_1.options.useDebugValue && preact_1.options.useDebugValue(u ? u(t) : t); }
    exports.useDebugValue = T;
    function q(n) { var r = m(t++, 10), o = l(); return r.__ = n, u.componentDidCatch || (u.componentDidCatch = function (n) { r.__ && r.__(n), o[1](n); }), [o[0], function () { o[1](void 0); }]; }
    exports.useErrorBoundary = q;
    function x() {
        i.forEach(function (t) {
            if (t.__P)
                try {
                    t.__H.__h.forEach(g), t.__H.__h.forEach(j), t.__H.__h = [];
                }
                catch (u) {
                    t.__H.__h = [], preact_1.options.__e(u, t.__v);
                }
        }), i = [];
    }
    preact_1.options.__b = function (n) { u = null, c && c(n); }, preact_1.options.__r = function (n) { f && f(n), t = 0; var r = (u = n.__c).__H; r && (r.__h.forEach(g), r.__h.forEach(j), r.__h = []); }, preact_1.options.diffed = function (t) { e && e(t); var o = t.__c; o && o.__H && o.__H.__h.length && (1 !== i.push(o) && r === preact_1.options.requestAnimationFrame || ((r = preact_1.options.requestAnimationFrame) || function (n) { var t, u = function () { clearTimeout(r), b && cancelAnimationFrame(t), setTimeout(n); }, r = setTimeout(u, 100); b && (t = requestAnimationFrame(u)); })(x)), u = void 0; }, preact_1.options.__c = function (t, u) {
        u.some(function (t) {
            try {
                t.__h.forEach(g), t.__h = t.__h.filter(function (n) { return !n.__ || j(n); });
            }
            catch (r) {
                u.some(function (n) { n.__h && (n.__h = []); }), u = [], preact_1.options.__e(r, t.__v);
            }
        }), a && a(t, u);
    }, preact_1.options.unmount = function (t) {
        v && v(t);
        var u = t.__c;
        if (u && u.__H)
            try {
                u.__H.__.forEach(g);
            }
            catch (t) {
                preact_1.options.__e(t, u.__v);
            }
    };
    var b = "function" == typeof requestAnimationFrame;
    function g(n) { var t = u; "function" == typeof n.__c && n.__c(), u = t; }
    function j(n) { var t = u; n.__c = n.__(), u = t; }
    function k(n, t) { return !n || n.length !== t.length || t.some(function (t, u) { return t !== n[u]; }); }
    function w(n, t) { return "function" == typeof t ? t(n) : t; }
}
